export const environment = {
  production: true,
  apiUrl: 'https://api.ggboost.com',
  stripeKey: 'pk_live_hfWw9AqTwvsIHIZ6jQg9hWri',
  amazonClientId: 'amzn1.application-oa2-client.ec83d0c983fe4b29bcff5e0a30c5c0ea',
  amazonSellerId: 'AQ6LOIRTXHYML',
  useAmazonSandbox: false,
  // TODO: set to the production Turnstile site key from the Cloudflare dashboard.
  turnstileSiteKey: '0x4AAAAAADn0aRYJsHpNxacO',
  tawk: {
    enabled: true,
    apps: {
      public: true,
      customer: true,
      booster: true,
      admin: false
    }
  }
};
